import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import MiniHero from "@modules/HeroModule/MiniHero"
import { useRedirectToPro } from "@hooks/siteURLs"
import { useBreakpoints } from "@hooks/useBreakpoints"
const Hero = () => {
  const { t } = useTranslation()
  const urlPro = useRedirectToPro()

  const { isMobile } = useBreakpoints()
  return (
    <MiniHero
      title={t("AboutMetaloop_Header")}
      subtitle={t("AboutMetaloop_Subheader")}
      image="metal-shavings-background.png"
      buttons={[
        {
          text: t("About_Button1"),
          as: "link",
          url: urlPro,
          useNavigate: false,
          inverted: true,
          theme: "blue-bg",
          dataEvent: {
            id: "Pro Form All",
            triggers: "GetStarted",
            source: "AboutMetaloop",
          },
        },
        {
          text: t("AboutMetaloop_CTA_Chat"),
          as: "link",
          url: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1kd4lu-7e_Th725jDj85XtJ91fL9ctPnwtctWkuTPrprua86XllJmsLKNPVLQZJYOXfq1tnH5y",
          inverted: false,
          theme: isMobile ? "white-bg" : "blue-bg",
          dataEventId: "calendar_patrick_case_studies_talk_to_a_specialist",
          source: "about us page",
          person: "Patrick",
        },
      ]}
      showGradientLayer={!isMobile}
      gradientStyle={{
        background:
          "linear-gradient(90deg, #151124 8.85%, rgba(21, 17, 36, 0.00) 100%)",
      }}
    />
  )
}
export default Hero
